// `DecompressionStream` is part of the Compression Streams web API. The
// browser-side TypeScript lib for older TS versions ships its type elsewhere
// (lib.dom.streams) and may not be present in CRA's default lib set. Declare
// it minimally here so the engine compiles without bumping the project's
// global TS lib config.
declare class DecompressionStream {
  constructor(format: "gzip" | "deflate" | "deflate-raw");
}

export async function gzipEncode(_bytes: Uint8Array, _level: number): Promise<Uint8Array> {
  throw new Error("gzipEncode not available in browser; encoding is server-side only");
}

export async function gzipDecode(bytes: Uint8Array): Promise<Uint8Array> {
  // Build a ReadableStream that emits exactly one Uint8Array chunk, pipe it
  // through DecompressionStream('gzip'), drain manually. Avoids using
  // `new Response(ab)` which has tripped up cross-browser body handling and
  // surfaces stream-errors as the misleading "TypeError: Failed to fetch".
  const input = new ReadableStream<Uint8Array>({
    start(controller) {
      controller.enqueue(bytes);
      controller.close();
    },
  });
  const ds = new DecompressionStream("gzip") as unknown as ReadableWritablePair<
    Uint8Array,
    Uint8Array
  >;
  const reader = input.pipeThrough(ds).getReader();
  const chunks: Uint8Array[] = [];
  let total = 0;
  for (;;) {
    const r = await reader.read();
    if (r.done) break;
    if (r.value) {
      chunks.push(r.value);
      total += r.value.byteLength;
    }
  }
  const out = new Uint8Array(total);
  let pos = 0;
  for (const c of chunks) {
    out.set(c, pos);
    pos += c.byteLength;
  }
  return out;
}
